import type { PredefinedSize } from "@/types/theme";

export function createThemeSizeObject(
  value: PredefinedSize["value"] = "",
  unit: PredefinedSize["unit"] = "unitless",
): PredefinedSize {
  return { cssType: "size", value, unit };
}
